<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-container">
      <!-- Header -->
      <div class="modal-header">
        <div class="modal-title">Add a Scheduling Note</div>
        <div class="close-button" (click)="onCancel()">
          <img src="assets/img/x.svg" class="close-icon" alt="close" />
        </div>
      </div>

      <!-- Form Content -->
      <form [formGroup]="form" class="form-content">
        <!-- Reason Dropdown -->
        <div class="form-field">
          <div class="field-label">Reason</div>
          <div class="dropdown-container" (click)="toggleReasonDropdown()">
            <div class="dropdown-input">
              <div class="dropdown-text" [class.placeholder]="!selectedReason">
                {{ selectedReason || 'Select here' }}
              </div>
            </div>
            <div class="dropdown-icon">
              <img
                src="assets/img/chevron-down.svg"
                class="chevron-down"
                [ngClass]="{ rotated: showReasonDropdown }"
                alt="chevron down" />
            </div>
          </div>

          <!-- Dropdown Options -->
          <div class="dropdown-options" *ngIf="showReasonDropdown" (click)="$event.stopPropagation()">
            <div class="dropdown-option" *ngFor="let reason of reasons" (click)="selectReason(reason)">
              <div class="option-text">{{ reason }}</div>
            </div>
          </div>
        </div>

        <!-- Note Textarea -->
        <div class="form-field">
          <div class="field-label">Note</div>
          <div class="textarea-container">
            <textarea
              class="note-textarea"
              placeholder="Type here"
              formControlName="note"
              rows="4"
              (input)="onTextareaInput($event)"></textarea>
          </div>
        </div>
      </form>

      <!-- Footer Buttons -->
      <div class="modal-footer">
        <div class="cancel-button" (click)="onCancel()">
          <div class="button-text">Cancel</div>
        </div>
        <div
          class="save-button"
          [class.disabled]="!form.valid || isSaving"
          [class.enabled]="form.valid && !isSaving"
          (click)="form.valid && !isSaving ? onSave() : null">
          <div class="button-text">
            <span *ngIf="!isSaving">Save</span>
            <span *ngIf="isSaving">Saving...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
